const ADDCATEGORY = "ADDCATEGORY";
const REMOVECATEGORY = "REMOVECATEGORY";
const UPDATECATEGORY = "UPDATECATEGORY";
const ADDCATEGORYVIDEO = "ADDCATEGORYVIDEO";
const REMOVECATEGORYVIDEO = "REMOVECATEGORYVIDEO";

export {ADDCATEGORY, REMOVECATEGORY, UPDATECATEGORY, ADDCATEGORYVIDEO, REMOVECATEGORYVIDEO};